import {
  ContentCopyOutlined,
  DeleteOutlineOutlined,
  Download,
  FileCopyOutlined,
  PublishedWithChanges,
  RestoreFromTrash,
  Settings,
  SortOutlined,
} from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import BusinessIcon from "@mui/icons-material/Business";
import UnsubscribeIcon from "@mui/icons-material/Unsubscribe";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FlatwareIcon from "@mui/icons-material/Flatware";
import {
  Box,
  Checkbox,
  CircularProgress,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import { ContextMenu } from "../ContextMenu/ContextMenu";

import CommentIcon from "@mui/icons-material/Comment";
import HistoryIcon from "@mui/icons-material/History";
import { Dialog } from "../Dialogs/Dialog";
import EditNoteIcon from "@mui/icons-material/EditNote";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import { ConfirmDialog } from "../Dialogs/ConfirmDialog";
import InfoIcon from "@mui/icons-material/Info";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { IStandardTableActionsProps } from "./StandardTableActions.types";

export interface IMenuOption {
  icon: React.ReactNode;
  label: string;
  disabled?: boolean;
  onClick?: () => void;
}
export interface IContextMenuProps {
  menuOptions: IMenuOption[];
}

export const StandardTableActions: React.FC<IStandardTableActionsProps> = (
  props,
) => {
  const {
    status,
    onDeleteClick,
    deleteConfirmContent,
    noConfirm,
    onReactiveClick,
    onViewClick,
    onQuickEditClick,
    onEditClick,
    onInfoClick,
    onEditCompanyClick,
    onEditSubscriptonClick,
    onEditOrgClick,
    onViewHistoryClick,
    onCommentClick,
    onDownLoadClick,
    onDownloadPreview,
    onDuplicateClick,
    onViewDetails,
    onWhatsappClick,
    onLeadFoodMenuClick,
    onWhatsappNewMessageClick,
    onRoughEstimationClick,
    onRoughEstimationPreviewClick,
    onRecoveryClick,
    onAnalyticsClick,

    downloadLoading,
    more,
    onSelect,
    isSelected,
    commentBoxTypeId,
    disableEdit,
    otherActions,
    customComponentActions,
  } = props;

  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [openReactiveConfirm, setOpenReactiveConfirm] = React.useState(false);

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"center"}
        alignItems={"center"}
        sx={{
          svg: {
            cursor: "pointer",
          },
        }}
        spacing={1}
      >
        {onSelect && (
          <Checkbox
            checked={!!isSelected}
            onChange={(e) => onSelect(e.target.checked)}
            color="primary"
            sx={{ padding: 0 }} // Adjust padding as needed
          />
        )}
        {onDeleteClick && status !== "INACTIVE" && status !== "ARCHIVE" && (
          <Box onClick={(e) => {
            e.stopPropagation();
            if (noConfirm) {
              onDeleteClick();
            } else {
              setOpenConfirm(true);
            }
          }}>
            <Tooltip title="Delete">
              <DeleteOutlineOutlined
                sx={{ cursor: "pointer" }}
                fontSize="small"
                color="error"
              />
            </Tooltip>
          </Box>
        )}
        {onReactiveClick && status === "INACTIVE" && (
          <Box onClick={(e) => { e.stopPropagation(); setOpenReactiveConfirm(true); }}>
            <Tooltip title="Reactive">
              <PublishedWithChanges
                sx={{ cursor: "pointer" }}
                fontSize="small"
                color="error"
              />
            </Tooltip>
          </Box>
        )}

        {onViewClick && (
          <Box onClick={(e) => { e.stopPropagation(); onViewClick(); }}>
            <Tooltip title="View">
              <VisibilityIcon color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}
        {onQuickEditClick && (
          <Box onClick={() => (disableEdit ? null : onQuickEditClick())}>
            <Tooltip title="Quick Edit">
              <EditNoteIcon
                sx={{ fontSize: 28 }}
                color={disableEdit ? "disabled" : "primary"}
              />
            </Tooltip>
          </Box>
        )}
        {onEditClick  && (
          <Box onClick={() => (disableEdit ? null : onEditClick())}>
            <Tooltip title="Edit">
              <EditIcon color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}
        {onInfoClick && (
          <Box onClick={() => (disableEdit ? null : onInfoClick())}>
            <Tooltip title="Edit">
              <InfoIcon color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}

        {onEditCompanyClick && (
          <Box onClick={() => (disableEdit ? null : onEditCompanyClick())}>
            <Tooltip title="Edit Company Information">
              <AccountBalanceIcon
                color={disableEdit ? "disabled" : "primary"}
              />
            </Tooltip>
          </Box>
        )}

        {onEditSubscriptonClick && (
          <Box onClick={() => (disableEdit ? null : onEditSubscriptonClick())}>
            <Tooltip title="Edit Subscription">
              <UnsubscribeIcon color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}

        {onEditOrgClick && (
          <Box onClick={() => (disableEdit ? null : onEditOrgClick())}>
            <Tooltip title="Edit Organization Environment Configuration">
              <Settings color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}

        {onDuplicateClick && (
          <Box onClick={onDuplicateClick}>
            <Tooltip title="Duplicate">
              <ContentCopyOutlined
                color={disableEdit ? "disabled" : "primary"}
              />
            </Tooltip>
          </Box>
        )}
        {onViewHistoryClick && (
          <Box onClick={onViewHistoryClick}>
            <Tooltip title="History">
              <HistoryIcon
                sx={{ fontSize: 26 }}
                color={disableEdit ? "disabled" : "primary"}
              />
            </Tooltip>
          </Box>
        )}
        {onCommentClick && (
          <Box onClick={onCommentClick}>
            <Tooltip title="Activity">
              <CommentIcon color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}
        {onDownloadPreview && (
          <Box onClick={onDownloadPreview}>
            <Tooltip title="Preview">
              <FileCopyOutlined color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}
        {onViewDetails && (
          <Box onClick={onViewDetails}>
            <Tooltip title="View Details">
              <SortOutlined color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}
        {onDownLoadClick && (
          <Box onClick={!downloadLoading ? onDownLoadClick : undefined}>
            <Tooltip title="Download">
              <Download color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}
        {onWhatsappClick && (
          <Box onClick={() => (disableEdit ? null : onWhatsappClick())}>
            <Tooltip title="WhatsApp">
              <WhatsAppIcon color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}
        {onLeadFoodMenuClick && (
          <Box onClick={() => (disableEdit ? null : onLeadFoodMenuClick())}>
            <Tooltip title="Lead Menu">
              <FlatwareIcon color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}
        {onWhatsappNewMessageClick && (
          <Box
            onClick={() => (disableEdit ? null : onWhatsappNewMessageClick())}
          >
            <Tooltip title="Not Replied">
              <WhatsAppIcon color="success" />
            </Tooltip>
          </Box>
        )}
        {onRoughEstimationClick && (
          <Box onClick={() => (disableEdit ? null : onRoughEstimationClick())}>
            <Tooltip title="Quotation">
              <AccountBalanceWalletIcon
                color={disableEdit ? "disabled" : "primary"}
              />
            </Tooltip>
          </Box>
        )}
        {onRoughEstimationPreviewClick && (
          <Box
            onClick={() =>
              disableEdit ? null : onRoughEstimationPreviewClick()
            }
          >
            <Tooltip title="Quotation Preview">
              <PictureAsPdfIcon color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}
        {onRecoveryClick && (
          <Box onClick={onRecoveryClick}>
            <Tooltip title="Recovery">
              <RestoreFromTrash color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}
        {onAnalyticsClick && (
          <Box onClick={onAnalyticsClick}>
            <Tooltip title="View Report">
              <EqualizerIcon color={disableEdit ? "disabled" : "primary"} />
            </Tooltip>
          </Box>
        )}

        {otherActions &&  otherActions  .filter((action) => !action.hide)
            .map((action, index) => (
              <Box key={index} onClick={!action.disabled ? action.onClick : undefined}>
                <Tooltip title={action.tooltip}>
                  <action.icon color={action.disabled ? "disabled" : "primary"} />
                </Tooltip>
              </Box>
            ))}

        {customComponentActions &&
          customComponentActions.map((action, index) => (
            <Box key={index}>{action.component}</Box>
          ))}

        {more && <ContextMenu menuOptions={more.menuItems}></ContextMenu>}
      </Stack>
      {downloadLoading && (
        <Dialog
          open={downloadLoading || false}
          size="sm"
          onClose={() => {}}
          title=""
        >
          <Stack
            minHeight={"200px"}
            justifyContent={"center"}
            direction={"column"}
            alignItems={"center"}
          >
            <CircularProgress size={40} />
            <Typography variant="h3" marginTop={2}>
              Download in progress..
            </Typography>
          </Stack>
        </Dialog>
      )}

      {openDeleteModal && (
        <Dialog
          title={
            status === "INACTIVE"
              ? "Are you sure you want to reactive?"
              : "Are you sure you want to delete?"
          }
          size="sm"
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          actions={[
            {
              type: "button",
              label: "Close",
              variant: "text",
              onClick: () => setOpenDeleteModal(false),
            },
            {
              type: "submit",
              label: "Confirm",
              variant: "contained",
              onClick: status === "INACTIVE" ? onReactiveClick : onDeleteClick,
            },
          ]}
        />
      )}

      {openConfirm && (
        <ConfirmDialog
          open={openConfirm}
          content={
            deleteConfirmContent ||
            "Are you sure you want to delete this item? By confirming, the associated transaction will be moved to the inactive stage."
          }
          onClose={() => setOpenConfirm(false)}
          onConfrim={() => {
            onDeleteClick?.();
            setOpenConfirm(false);
          }}
        />
      )}

      {openReactiveConfirm && (
        <ConfirmDialog
          open={openReactiveConfirm}
          content="Are you sure you want to reactive this item? By confirming, the associated transaction will be moved to the active stage."
          onClose={() => setOpenReactiveConfirm(false)}
          onConfrim={() => {
            onReactiveClick?.();
            setOpenReactiveConfirm(false);
          }}
        />
      )}
    </>
  );
};
